exports.ColumnasTabla = Object.freeze(
  {
    Productor: "Productor",
    Establecimiento: "Establecimiento",
    Fecha: "Fecha",
    Localidad: "Localidad"
  }
);

exports.Herramientas = {
  PerspectivasClimaticas: {
    id: 1,
    routeName: "PerspectivasClimaticas",
    description: "Brindamos informes climatológicos elaborados por el Laboratorio Climatológico Sudamericano, que te permiten realizar una planificación estratégica con seis meses de anticipación.",
    title: "Perspectivas climáticas de la campaña",
    path: "/perpectivas-climaticas",
    icon: "cloud-sun"
  },
  Suelos: {
    id: 2,
    routeName: "Suelos",
    description: "",
    title: "Análisis químico y físico de suelo",
    path: "/suelos",
    icon: "flask"
  },
  Aguas: {
    id: 3,
    routeName: "Aguas",
    description: "",
    title: "Análisis de agua útil",
    path: "/aguas",
    icon: "water"
  },
  Pluviometros: {
    id: 4,
    routeName: "Pluviometros",
    description: "",
    title: "Registro pluviométrico mensual",
    path: "/pluviometros",
    icon: "cloud-showers-heavy"
  },
  Freatimetros: {
    id: 5,
    routeName: "Freatimetros",
    description: "",
    title: "Registro de napa freática mensual",
    path: "/freatimetros",
    icon: "ruler-vertical"
  },
  Satelitales: {
    id: 6,
    routeName: "Satelitales",
    description: "Estudio digital de tu lote; a través del análisis de imágenes satelitales obtenidas del software AtFarm, te brindamos un reporte del diagnóstico del crecimiento de tu cultivo.",
    title: "Seguimiento del Cultivo con Imágenes Satelitales (Atfarm)",
    path: "/satelitales",
    icon: "satellite"
  },
  Veris: {
    id: 7,
    routeName: "Veris",
    description: "El equipo cuenta con herramientas como Rastra Veris, calador hidráulico y Soiloptix que permiten registrar la variabilidad existente en el lote de estudio.",
    title: "Ambientación del lote con Rastra Veris y scanner SoilOptix",
    path: "/veris",
    icon: "images"
  },
  MonitoreoDron: {
    id: 8,
    routeName: "MonitoreoDron",
    description: "A través de un monitoreo de vuelo con un Dron (Corteva Flight), que te permite identificar eficiencia de siembra, como así también presencia de malezas y ataques tempranos de cogollero.",
    title: "Monitoreo de precisión con Dron (Corteva Flight)",
    path: "/monitoreo-dron",
    icon: "video"
  },
  ServicioFertilizacion: {
    id: 9,
    routeName: "ServicioFertilizacion",
    description: "Ofrecemos el servicio de fertilización y siembra variable para que pueda producir de manera eficaz tus cultivos.",
    title: "Servicio de fertilización sólida variable / Siembra variable",
    path: "/servicio-fertilizacion",
    icon: "seedling"
  },
  AnalisisPostcosecha: {
    id: 10,
    routeName: "AnalisisPostcosecha",
    description: "Brindamos un reporte de los resultados obtenidos en la campaña.",
    title: "Análisis de resultados postcosecha",
    path: "/analisis-postcosecha",
    icon: "clipboard"
  },
  GetHerramientaById(id){
    return Object.values(this).find(
      obj => obj.id == id
    );
  },
  GetValues(){
    let result = Object.values(this).filter(
      obj => obj.id != null
    );
    return result;
  },
  GetIdHerramientaByRouteName(routeName){
    let result = Object.values(this).find(
      obj => obj.routeName == routeName
    );
    return result ? result.id : -1;
  },
  GetHerramientaByIds(arrayIds){
    return Object.values(this).filter(
      obj => arrayIds.includes(obj.id)
    );
  },
  GetRecordsPath(idHerramienta, idHerramientaEstablecimiento){
    let herramienta = this.GetHerramientaById(idHerramienta);
    if (!herramienta) return "";
    return `${herramienta.path}/${idHerramientaEstablecimiento}`;
  }
};
